export default {

  queryInstance: null,
  queryInstanceDetalle: null,

  handleFormValidation() {
    const oForm = $('#form-reporte-sql');

    const aRules = {
      nombre: {
        required: true
      },
      query: {
        required: true,
      }
    };

    const aMessages = {
      nombre: {
        required: 'El campo Nombre es obligatorio.'
      },
      query: {
        required: 'El campo Consulta SQL es obligatorio.',
      }
    };

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  initSqlSyntax(textAreaId, autofocus) {
    const queryInstance = CodeMirror.fromTextArea(document.getElementById(textAreaId), {
      mode: 'text/x-mysql',
      indentWithTabs: true,
      smartIndent: true,
      lineNumbers: true,
      matchBrackets: true,
      autofocus: autofocus || false,
    });
    queryInstance.on('change', () => {
      queryInstance.save();
    });
  },

  showModalReport(e) {
    const $linkEl = $(e.currentTarget);
    const $modalEl = $($linkEl.data('target'));
    const $iframeEl = $('#modal-iframeContent');
    const $loaderEl = $('.js-loader');

    if ($iframeEl.length > 0) {
      $iframeEl.on('load', function() {
        $loaderEl.hide();
      });

      $iframeEl.attr('src', $linkEl.data('href'));
    }

    if ($modalEl.length > 0) {
      $loaderEl.show();
      $modalEl.modal('show');
    }
  },

  init() {
    this.handleFormValidation();
    this.initSqlSyntax('txtQueryArea', true);

    for (let i = 1; i <= 5; i++) {
      this.initSqlSyntax('txtQueryAreaDetalle' + i);
    }

    $('#cmbVisualizadores').select2({
      placeholder: "Seleccionar...",
      allowClear: true
    });

    $(".js-tags").select2({
      tags: true,
      tokenSeparators: [','],
      placeholder: "Seleccionar o agregar...",
      allowClear: true,
      createTag: function (params) {
        const term = $.trim(params.term);

        if (term === '') {
          return null;
        }

        return {
          id: term,
          text: term,
          newTag: true
        }
      },
      insertTag: function (data, tag) {
        // Insert the tag at the end of the results
        data.push(tag);
      }
    })
  },

  initIndex() {
    FormHelper.handleSearch();

    $(".select2").select2({
      placeholder: "Seleccionar...",
      allowClear: true
    });
  },

  /**
   * Elimina un registro a través de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} nombre Nombre del registro a eliminar
   */
  eliminar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas eliminar el Reporte SQL <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
    FormHelper.confirm(form, mensaje);
  },
};
